import React from 'react'

type AutoPlayContextProps = {
  playingUrl?: string
  playQueueLength: number
  addToQueue: (audioUrl: string) => void
  removeFromQueue: (audioUrl: string) => void
}

const AutoPlayContext = React.createContext<AutoPlayContextProps>(
  {} as AutoPlayContextProps
)

const AutoPlayProvider = ({ children }: { children: React.ReactNode }) => {
  const [playingUrl, setPlayingUrl] = React.useState<string>()
  const playQueue = React.useRef<string[]>([])

  const addToQueue = (audioUrl: string) => {
    if (playQueue.current.includes(audioUrl)) return
    playQueue.current = [...playQueue.current, audioUrl]
    handleQueueChange()
  }

  const removeFromQueue = (audioUrl: string) => {
    playQueue.current = playQueue.current.filter((url) => url !== audioUrl)
    handleQueueChange()
  }

  const handleQueueChange = () => {
    if (playQueue.current.length) {
      setPlayingUrl(playQueue.current[0])
      return
    }
    setPlayingUrl(undefined)
  }

  return (
    <AutoPlayContext.Provider
      value={{
        playingUrl,
        playQueueLength: playQueue.current?.length || 0,
        addToQueue,
        removeFromQueue
      }}
    >
      {children}
    </AutoPlayContext.Provider>
  )
}

export default AutoPlayProvider

export const useAutoPlay = () => React.useContext(AutoPlayContext)
